import { themedColor } from '@lemonade-hq/cdk';
import { Pill } from '@lemonade-hq/nuis';
import type React from 'react';
import styled, { keyframes } from 'styled-components';

const fade = keyframes`
   0% {
        opacity: 0;
        transform: translateY(10px)
    }
    100% {
        opacity: 1;
        transform: translateY(0)
    }
`;

const StyledPill = styled(Pill)`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: ${themedColor('primary')};
  color: ${themedColor('white')};
  animation: ${fade} 250ms ease;
`;

export const Badge: React.FC = () => {
  return <StyledPill>bundle</StyledPill>;
};
